import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';
import { limit } from 'firebase/firestore';
import { NotificationService } from 'src/app/shared/notification.service';
import { map, Observable } from 'rxjs';
import moment from  'moment-timezone/builds/moment-timezone-with-data-1970-2030.min.js';

@Injectable({
  providedIn: 'root'
})
export class SimListService {

  constructor(private afs: AngularFirestore, private notificationnService: NotificationService) { }

  getList$(status?: String): Observable<any> {
    return this.afs.collection('sim').snapshotChanges().pipe(
      map(actions => actions.map(a => {
        const data = a.payload.doc.data() as any;
        const id = a.payload.doc.id;
        return { id, 
          ...data,
          dateSessionStartedAgo: data.dateSessionStarted? moment(data.dateSessionStarted).fromNow(): "",
          dateSessionEndedAgo: data.dateSessionEnded? moment(data.dateSessionEnded).fromNow(): ""
        };
      }))
    );
  }

  updateSimInfo(iccid: string){
    this.afs.collection('sim').doc(iccid).update({ update: true })
      .then(() => {
      // Notify success
      this.notificationnService.showNotification('success', 'Update request sendt')
      })
      .catch((error) => {
      // Notify error
      this.notificationnService.showNotification('error', 'Failed to send update request')
      });
  }

  addSim(iccid: String) {}

  removeSim(iccid: String) {}

}
